// extracted by mini-css-extract-plugin
export default {"stars":"quizBottomAppBar_stars__g8sTa"};